<script>
import { message } from 'ant-design-vue';
import { v4 as uuidv4 } from 'uuid';

export default {
  data() {
    return {
      previewImage: '',
      previewVisible: false,
      imageList: [],
    };
  },
  props: {
    isMultiple: {
      type: Boolean,
      required: true,
    },
    initialImages: {
      type: Array,
    },
    withUpdateInitialImages: {
      type: Boolean,
      default: false,
    },
    classProps: {
      type: Array,
    },
    onRemove: {
      type: Function,
      required: false,
      default: () => {},
    },
    maxNumber: {
      type: Number,
      default: 9,
    },
    showPreviewIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    showRemoveIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    showDownloadIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mounted() {
    if (this.initialImages && this.initialImages.length > 0) {
      this.imageList = this.initialImages.map((item) => ({
        status: 'done',
        id: uuidv4(),
        url: item,
        file: null,
      }));
      this.$emit('update:files', this.imageList);
    }
  },
  watch: {
    initialImages: {
      handler(newValue) {
        if (newValue && this.withUpdateInitialImages) {
          this.imageList = newValue.map((item) => (!item.id ? {
            status: 'done',
            id: uuidv4(),
            url: item,
            file: null,
          } : item));
          this.$emit('update:files', this.imageList);
        }
      },
      deep: true,
    },
  },
  methods: {
    getBase64(img, callback) {
      const reader = new FileReader();
      reader.onload = () => callback(reader.result);
      reader.readAsDataURL(img);
    },
    handleRemove(file) {
      this.imageList = this.imageList.filter((item) => item.id !== file.id);
      this.$emit('update:files', this.imageList);
      this.onRemove(file);
    },
    handlePreview(file) {
      this.previewImage = file.url;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleChange(info) {
      this.getBase64(info.file, (base64Url) => {
        this.imageList = [...this.imageList, {
          status: 'done',
          id: uuidv4(),
          url: base64Url,
          file: info.file,
        },
        ];
        this.$emit('update:files', this.imageList);
      });
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        message.error('You can only upload JPG or PNG file!');
      }
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        message.error('Image must be smaller than 20MB!');
      }
      return isJpgOrPng && isLt20M;
    },
  },
};
</script>

<template>
  <a-upload
    name="image"
    list-type="picture-card"
    :file-list="imageList"
    class="image-uploader"
    :class="classProps"
    :show-upload-list="{
      showPreviewIcon: this.showPreviewIcon,
      showRemoveIcon: this.showRemoveIcon,
      showDownloadIcon: this.showDownloadIcon,
    }"
    :before-upload="beforeUpload"
    :custom-request="handleChange"
    :remove="handleRemove"
    @preview="handlePreview"
    :show-remove-icon="false"
  >
    <div
        v-if="(isMultiple && this.imageList.length < this.maxNumber)
        || (!isMultiple && this.imageList.length < 1)"
    >
      <div class="ant-upload-text">Upload</div>
    </div>
  </a-upload>
  <a-modal :open="previewVisible" :footer="null" @cancel="handleCancel">
    <img alt="example" style="width: 100%" :src="previewImage" />
  </a-modal>
</template>

<style scoped lang="scss">
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .img {
    width: 100px;
    height: 100px;
  }
</style>
